import { render, staticRenderFns } from "./icon-with-text-slider.vue?vue&type=template&id=7ba51f8c&"
import script from "./icon-with-text-slider.vue?vue&type=script&lang=js&"
export * from "./icon-with-text-slider.vue?vue&type=script&lang=js&"
import style0 from "./icon-with-text-slider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports